import { MenuCategories } from '../hooks/useGetCategories'

import MenuSection from './MenuSection'

export default function MegaMenuDesktop({ categories }: { categories: MenuCategories }): React.ReactElement {
  const { learningTools, games, profile } = categories

  return (
    <div className="relative flex px-3 pb-6 pt-7">
      <div className="min-w-px flex-1 px-5">
        <MenuSection category={learningTools} />
      </div>
      <div className="min-w-px flex-1 border-l border-gray-ghost px-5">
        <MenuSection category={games} />
      </div>
      {profile && (
        <div className="min-w-px flex-1 border-l border-gray-ghost px-5">
          <MenuSection category={profile} />
        </div>
      )}
    </div>
  )
}
